import { render, staticRenderFns } from "./ImportarBeneficiarios.vue?vue&type=template&id=4a5e8d1b&scoped=true"
import script from "./ImportarBeneficiarios.vue?vue&type=script&lang=js"
export * from "./ImportarBeneficiarios.vue?vue&type=script&lang=js"
import style0 from "./ImportarBeneficiarios.vue?vue&type=style&index=0&id=4a5e8d1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e8d1b",
  null
  
)

export default component.exports